import gsap from "gsap";
import { Power1, Power3 } from "gsap";
export const enterTransition = () => {
    return gsap.to('.overlay', {
        display: 'block', 
        top: '-6.4rem', 
        duration: 0.4,
        ease: Power3.in
    });
}
